export default __webpack_public_path__ + "media/images/main/calendar-20214f4655a8ddbff40d62d645cb45c5.png";